module.exports = __webpack_public_path__ + "static/media/details4.b9c372b8.svg";